/**
 * Modern Menu Template
 * Minimalist and elegant dark design
 */
import React from "react";
import { FTU_LOGO_URL } from "../constants";

export function ModernTemplate({ 
  menuRef,
  generatedMenu, 
  showPrix,
  customLogoUrl,
  pageOrientation = "portrait"
}) {
  if (!generatedMenu) return null;

  return (
    <div
      ref={menuRef}
      className="relative p-4"
      style={{
        width: pageOrientation === "landscape" ? "297mm" : "210mm",
        minHeight: pageOrientation === "landscape" ? "210mm" : "297mm",
        background: "linear-gradient(180deg, #1a1a2e 0%, #16213e 100%)",
      }}
    >
      {/* Content */}
      <div className="relative z-10 h-full flex flex-col p-6">
        {/* Header */}
        <div className="text-center mb-6">
          {customLogoUrl && (
            <img 
              src={customLogoUrl} 
              alt="Logo"
              className="h-16 mx-auto mb-3 drop-shadow-lg"
            />
          )}
          <h1 className="text-3xl font-bold text-white tracking-wider">
            {generatedMenu.titre || "MENU"}
          </h1>
          {generatedMenu.sous_titre && (
            <p className="text-gray-400 text-sm mt-1">{generatedMenu.sous_titre}</p>
          )}
          <div className="w-16 h-0.5 bg-gradient-to-r from-transparent via-amber-400 to-transparent mx-auto mt-3" />
        </div>
        
        {/* Menu Grid */}
        <div className="flex-1 grid grid-cols-2 gap-4">
          {generatedMenu.sections?.map((section, sIdx) => (
            <div key={sIdx} className="space-y-3">
              <h2 className="text-amber-400 font-semibold text-lg border-b border-amber-400/30 pb-1">
                {section.titre}
              </h2>
              {section.plats?.map((plat, pIdx) => (
                <div key={pIdx} className="flex gap-3 bg-white/5 rounded-lg p-2 backdrop-blur">
                  {/* Photo */}
                  <div className="w-16 h-16 rounded-lg overflow-hidden flex-shrink-0 bg-gray-700">
                    {plat.image_url ? (
                      <img src={plat.image_url} alt={plat.nom} className="w-full h-full object-cover" />
                    ) : (
                      <div className="w-full h-full flex items-center justify-center text-2xl">
                        {section.type === "entree" ? "🥗" :
                         section.type === "plat" ? "🍽️" :
                         section.type === "dessert" ? "🍰" : "🥤"}
                      </div>
                    )}
                  </div>
                  {/* Info */}
                  <div className="flex-1 min-w-0">
                    <div className="flex justify-between items-start">
                      <h3 className="text-white font-medium text-sm">{plat.nom}</h3>
                      {showPrix && (
                        <div className="flex items-center gap-1">
                          {plat.original_prix && plat.original_prix !== plat.prix && (
                            <span className="text-gray-500 text-xs line-through">{plat.original_prix.toFixed(0)}€</span>
                          )}
                          <span className={`font-bold text-sm ${plat.original_prix && plat.original_prix !== plat.prix ? 'text-orange-400' : 'text-amber-400'}`}>
                            {plat.prix.toFixed(0)} €
                          </span>
                        </div>
                      )}
                    </div>
                    {plat.description && (
                      <p className="text-gray-400 text-xs mt-0.5 line-clamp-2">{plat.description}</p>
                    )}
                  </div>
                </div>
              ))}
            </div>
          ))}
        </div>
        
        {/* Footer */}
        <div className="text-center mt-4 pt-3 border-t border-gray-700">
          {/* Logo Food Truck United */}
          <img 
            src={FTU_LOGO_URL} 
            alt="Food Truck United" 
            className="h-8 mx-auto mb-2 brightness-0 invert opacity-50"
          />
          <p className="text-gray-500 text-xs">{generatedMenu.food_truck?.nom}</p>
          <p className="text-gray-600 text-xs mt-1">Pour toutes allergies, merci de nous consulter</p>
        </div>
      </div>
    </div>
  );
}

export default ModernTemplate;
